(function () {
  const swiperContainer = document.querySelector("[data-swiper-container]");

  if (!swiperContainer) return;

  let swiperLoaded = false;

  function loadSwiper() {
    if (swiperLoaded) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src =
        "https://cdn.jsdelivr.net/npm/swiper@12/swiper-element-bundle.min.js";
      script.onload = () => {
        swiperLoaded = true;
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function initializeSwipers() {
    const mainSwiper = document.querySelector(".product-main-image");
    const thumbsSwiper = document.querySelector(".product-thumbnails-swiper");
    const thumbnails = document.querySelectorAll(".product-thumbnail");

    if (!mainSwiper) return;

    if (thumbsSwiper) {
      thumbsSwiper.initialize();
    }

    mainSwiper.initialize();

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener("click", () => {
        thumbnails.forEach((thumb) => thumb.removeAttribute("aria-current"));
        thumbnail.setAttribute("aria-current", "true");

        if (mainSwiper.swiper) {
          mainSwiper.swiper.slideTo(index);
        }
      });
    });

    mainSwiper.addEventListener("slidechange", (event) => {
      const activeIndex = event.detail[0].realIndex;

      thumbnails.forEach((thumb, index) => {
        if (index === activeIndex) {
          thumb.setAttribute("aria-current", "true");
        } else {
          thumb.removeAttribute("aria-current");
        }
      });
    });
  }

  let interactionDetected = false;

  function handleInteraction() {
    if (interactionDetected) return;
    interactionDetected = true;

    loadSwiper()
      .then(() => {
        initializeSwipers();
      })
      .catch((error) => {
        console.error("Erreur lors du chargement de Swiper:", error);
      });

    document.removeEventListener("scroll", handleInteraction);
    document.removeEventListener("mousemove", handleInteraction);
    document.removeEventListener("touchstart", handleInteraction);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          handleInteraction();
          observer.disconnect();
        }
      });
    },
    {
      rootMargin: "50px",
    },
  );

  observer.observe(swiperContainer);

  document.addEventListener("scroll", handleInteraction, {
    passive: true,
    once: true,
  });
  document.addEventListener("mousemove", handleInteraction, {
    passive: true,
    once: true,
  });
  document.addEventListener("touchstart", handleInteraction, {
    passive: true,
    once: true,
  });

  setTimeout(() => {
    if (!interactionDetected) {
      handleInteraction();
    }
  }, 3000);
})();
